<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :actionsComponent="componentForActions"
      :delete_url="delete_url"
    >
    </DataTable>
  </div>
</template>

<script>
import DataTable from "@/own/components/DataTable.vue";
import {
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/fileExports.module";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import DataTableActionSelectorNew from "@/own/components/DataTableActionSelectorNew.vue";

export default {
  name: "FileExports",
  components: { DataTable },
  data: () => ({
    componentForActions: DataTableActionSelectorNew,
    delete_url: `${process.env.VUE_APP_BASE_URL}/settings/file_exports/destroy`,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORTBY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PERPAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
    },
    store_names: {
      getTableFilters: "getFILEEXPORTSTableFilters",
      getTableState: "getFILEEXPORTSTableState",
      getTableData: "getFILEEXPORTSTableData",
      getTableHeaders: "getFILEEXPORTSTableHeaders",
      getTableProperties: "getFILEEXPORTSTableProperties",
      getTablePermissions: "getFILEEXPORTSTablePermissions",
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
    },
  },
  computed: {
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
